import useGoToNavigation from "../../../../../util/useGotoNavigation";
import {PcsDetailType} from "../interface";
import React, {Dispatch, SetStateAction} from "react";
import {useModal} from "../../../../../hooks";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";

interface PropsType {
    pcsDetail: PcsDetailType
    isModify: boolean
    setIsModify: Dispatch<SetStateAction<boolean>>
    btnSave: () => void
    menuTitleText: string
    urlText: string
    isAvailableOrder: boolean | undefined
    isPcsDelivery: boolean | undefined
}

export default function Upper({
                                  pcsDetail,
                                  isModify,
                                  setIsModify,
                                  btnSave,
                                  menuTitleText,
                                  urlText,
                                  isAvailableOrder,
                                  isPcsDelivery
                              }: PropsType) {
    const {goToNavigation} = useGoToNavigation();
    const {handleModal} = useModal();

    const goToList = () => {
        goToNavigation(`${urlText}/list`, {}, false)
    }

    const goToOrders = () => {
        if (!pcsDetail.newLAddressValue && pcsDetail.newLAddressValue === "") {
            handleModal({
                isOpen: true,
                contents: "발송지 입력 후 수주 등록할 수 있습니다.",
                type: "alert"
            })

            return;
        }

        goToNavigation(`order/orders/create?i=${pcsDetail.purchaseOrderId}`, {}, false)
    }

    const btnToggleModify = () => {
        setIsModify(!isModify)
    }

    return <div className="content_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">{menuTitleText}상세보기</h3>
            <div className="filter_toolbar">
                {!isModify ? <>
                        <button className="btn btn-outline-primary w-100px h-38px" onClick={goToList}>
                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt=""/>목록
                        </button>
                        {isAvailableOrder && pcsDetail.purchaseOrderState != 2 &&
                            <AuthorityChecker authorityNames={['shipmentWriteYn']}>
                                <button className="btn btn-info w-100px h-38px" onClick={goToOrders}>수주</button>
                            </AuthorityChecker>
                        }
                        {pcsDetail.purchaseOrderState != 2 &&
                            <AuthorityChecker authorityNames={['orderWriteYn']}>
                                <button className="btn btn-secondary w-100px h-38px" onClick={btnToggleModify}>수정
                                </button>
                            </AuthorityChecker>
                        }
                    </> :
                    <>
                        <button className="btn btn-primary w-100px h-38px" onClick={btnSave}>
                            저장
                        </button>
                        <button className="btn btn-outline-secondary w-100px h-38px" onClick={btnToggleModify}>
                            취소
                        </button>
                    </>
                }
            </div>
        </div>
        <h5 className="subheading">{menuTitleText}정보</h5>
        <div className="table_scroll mb-0">
            <table className="table table-bordered my_table table_detail">
                <tbody>
                <tr>
                    <th style={{width: "16.66%"}}>{menuTitleText}번호</th>
                    <td style={{width: "33.34%"}}>{menuTitleText.includes("납품") ? pcsDetail.shipmentNo : pcsDetail.purchaseOrderNo}</td>
                    <th style={{width: "16.66%"}}>상태</th>
                    <td>{isPcsDelivery ? pcsDetail.progressName : pcsDetail.purchaseOrderStateName}</td>
                </tr>
                <tr>
                    <th>{menuTitleText}일자</th>
                    <td>{menuTitleText.includes("납품") ? pcsDetail.newDtShipment : pcsDetail.purchaseOrderDt}</td>
                    <th>주문자</th>
                    <td>{pcsDetail.ordererName}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
}